export type EquipmentValue = {
  id?: number | string | null;
  name?: string | null;
} | null;

type Params = {
  equipment: EquipmentValue;
  allowedEquipmentIds: Array<number | undefined>;
  itemIndex: number;
};

export default function validateEquipmentIsFromProcess({
  equipment,
  allowedEquipmentIds,
  itemIndex,
}: Params) {
  const equipmentId = (() => {
    const raw = equipment?.id;
    if (raw === null || raw === undefined) return raw;
    if (typeof raw === "number") return raw;
    const parsed = Number(raw);
    return Number.isNaN(parsed) ? null : parsed;
  })();

  if (equipmentId === null || equipmentId === undefined) return true;

  return allowedEquipmentIds.includes(equipmentId)
    ? true
    : `Item de carga ${itemIndex + 1} - Equipamento não pertence ao processo.`;
}

